import { render, staticRenderFns } from "./practicalActivity.vue?vue&type=template&id=1c5d8501&scoped=true"
import script from "./practicalActivity.vue?vue&type=script&lang=js"
export * from "./practicalActivity.vue?vue&type=script&lang=js"
import style0 from "./practicalActivity.vue?vue&type=style&index=0&id=1c5d8501&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d8501",
  null
  
)

export default component.exports